/*
  Project module
  ---
  This is the v2 of the 'project' module
  This will contain general project storage
*/

import router from '@src/router'
import * as api from '@utils/api.js'
// import filter from 'lodash/filter'
// import split from 'lodash/split'
// import forEach from 'lodash/forEach'
// import includes from 'lodash/includes'
// import union from 'lodash/union'
// import orderBy from 'lodash/orderBy'

const state = {
  data: null,

  loadedOn: null,
  loaded: false,
  loading: false,
  loadingError: false
}

const getters = {
  project(state) {
    return state.data
  },

  loading(state) {
    return state.loading
  },
  loaded(state) {
    return state.loaded
  },
  loadingError(state) {
    return state.loadingError
  }
}

const mutations = {
  addData(state, data) {
    state.data = data
  },

  setLoading(state) {
    state.loading = true
    state.loadingError = false
  },
  setLoaded(state) {
    state.loading = false
    state.loadingError = false
    state.loaded = true
    state.loadedOn = Date.now()
  },
  setLoadingError(state) {
    state.loading = false
    state.loadingError = true
  },
  setProjectCover(state, { id, cover }) {
    for (let index = 0; index < state.data.length; index++) {
      if (state.data[index].id === id) {
        state.data[index].cover = cover
      }
    }
  },
  handleNavigation() {
    const routeName = router.currentRoute.name
    if (routeName === 'drive-select') router.go(0) // redirects to the same page
    else router.push({ name: 'drive-select' })
  },
  clear(state) {
    state.data = null
    state.loaded = false
    state.loading = false
    state.loadingError = false
  }
}

const actions = {
  clear({ commit }) {
    commit('clear')
  },

  loadProject({ commit, dispatch }, { projectId }) {
    // Base Api call
    let uri = 'api/v1/projects/' + projectId
    commit('setLoading')
    return api
      .rawApiGetCall(uri)
      .then((response) => {
        return dispatch('handleReturn', response.data.data)
      })
      .catch((error) => {
        commit('clear')
        commit('setLoadingError')
        commit('handleNavigation')
      })
  },

  setLoading({ commit, state }) {
    commit('setLoading', state)
  },

  handleReturn({ commit, dispatch }, data) {
    commit('addData', data)
    return data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
